import useTeamStore from '../store/teamStore';

export const useGetTeamMembersMap = () => {
  const members = useTeamStore((state) => state.members.list);
  return members?.reduce((membersMap, member) => {
    // eslint-disable-next-line no-param-reassign
    membersMap[member.userId] = member;
    return membersMap;
  }, {}) || {};
};
